export enum Routes {
  FleetRegistrationRouter = "*",
  RegistrationExpirySearchPageRouter = "/fleet/registration-expiry/search",
}
